@if (!inUnderConstruction()) {
  <div class="page-content" [ngClass]="{ 'disable-page': mainStore.isLoading() }">
    <pc-app-header
      [agentName]="processTypeStore.entityName()"
      [disclaimerName]="processTypeStore.disclaimerText()"
      [entityBannerText]="translations.splashScreen.activeWith | translate"
      [headerData]="headerData()"
      [isAgentProcess]="processTypeStore.showHeaderBanner()"
      [isNavigationLocked]="mainStore.isNavigationLocked()"
      [isShowDisclaimer]="shouldShowHeaderDiclamer()"
      (accStmtClick)="accStmtClick()"
    >
    </pc-app-header>

    <main
      #scrollContainer
      cdkScrollable
      [ngClass]="{
        'withQuote-grid': showQuoteOverview(),
        'noQuote-grid': !showQuoteOverview(),
        'with-footer': showFooter()
      }"
    >
      <pc-background-main-image [borderRadius]="isDesktop() ? 30 : 0" [image]="bgImage()"></pc-background-main-image>
      @if (!isDataLoading()) {
        @if (isDesktop() && showQuoteOverview()) {
          <pc-quote-overview></pc-quote-overview>
        }
        <section>
          <router-outlet></router-outlet>
          <div class="bottom-section">
            @if (showDisclaimer()) {
              <p class="tags-small" [innerHTML]="translations.tripDetailsDisclaimer | translate"></p>
            }
          </div>
        </section>
      }
    </main>

    @if (showFooter()) {
      <pc-app-footer
        [footerData]="footerData()"
        [isDisabled]="isContinueDisabled()"
        [quoteOverviewLabels]="quoteOverviewService.quoteOverviewLabels()"
        [showQuoteOverviewFooter]="showQuoteOverview()"
        [totalPrice]="quoteOverviewService.totalPremium()"
        (backClk)="onBckBtnClick()"
        (nextClk)="onNextBtnClick()"
      >
      </pc-app-footer>
    }
  </div>
} @else {
  <div class="under-construction-wrapper">
    <router-outlet></router-outlet>
  </div>
}
